var he = Object.defineProperty;
var ve = (o, s, t) => s in o ? he(o, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[s] = t;
var H = (o, s, t) => ve(o, typeof s != "symbol" ? s + "" : s, t);
import { defineComponent as de, ref as d, computed as j, reactive as q, onMounted as me, nextTick as ge, onBeforeUnmount as pe, createElementBlock as F, openBlock as G, normalizeStyle as b, normalizeClass as J, createElementVNode as W, renderSlot as D, createCommentVNode as x, unref as B } from "vue";
class K {
  constructor(s, t) {
    H(this, "x", 0);
    H(this, "y", 0);
    this.x = s || 0, this.y = t || 0;
  }
  set(s, t) {
    this.x = s, this.y = t;
  }
  substract(s) {
    this.x -= s.x, this.y -= s.y;
  }
}
function Q(o) {
  const { onDown: s, onMove: t, onUp: r } = o, a = new K(), e = new K();
  let v;
  function h(c) {
    c.stopPropagation(), e.set(c.x, c.y), e.substract(a), t(a, e, c, v);
  }
  function m(c) {
    r(c, v), a.set(0, 0), document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", m);
  }
  return (c, g) => s(c, g) ? (v = g, a.set(c.x, c.y), document.addEventListener("mousemove", h), document.addEventListener("mouseup", m), c.stopPropagation(), !0) : !1;
}
function ze(o) {
  const { onDown: s, onUp: t } = o;
  function r(a) {
    t(a), document.removeEventListener("mouseup", r);
  }
  return (a) => s(a) ? (document.addEventListener("mouseup", r), a.preventDefault(), a.stopPropagation(), !0) : !1;
}
function ke(o, s) {
  let t = 0;
  return {
    start() {
      t > 0 && clearTimeout(t), t = setTimeout(() => {
        t = 0, s();
      }, o);
    },
    stop() {
      t > 0 && (clearTimeout(t), t = 0);
    }
  };
}
function we(o, s) {
  let t = 0;
  return {
    start() {
      t > 0 && clearInterval(t), t = setInterval(() => {
        t = 0, s();
      }, o);
    },
    stop() {
      t > 0 && (clearInterval(t), t = 0);
    }
  };
}
function Z(o, s) {
  let t = null, r = 0;
  return function(...a) {
    const e = Date.now(), v = e - r, h = s - v;
    h <= 0 ? (r = e, o.apply(this, a)) : (t !== null && window.clearTimeout(t), t = window.setTimeout(() => {
      r = Date.now(), t = null, o.apply(this, a);
    }, h));
  };
}
const S = [], _ = we(100, () => {
  for (const o of S)
    o();
});
function Te(o, s, t, r) {
  let a = 0, e = 0;
  function v() {
    o.value && (s && a !== o.value.offsetWidth && s(o.value.offsetWidth), t && e !== o.value.offsetHeight && t(o.value.offsetHeight), r && (a !== o.value.offsetWidth || e !== o.value.offsetHeight) && r(o.value.offsetWidth, o.value.offsetHeight), a = o.value.offsetWidth, e = o.value.offsetHeight);
  }
  return {
    startResizeChecker() {
      _.start(), S.push(v);
    },
    stopResizeChecker() {
      const h = S.indexOf(v);
      h >= 0 && S.splice(h, 1), S.length === 0 && _.stop();
    }
  };
}
const Se = 140, ye = 120, be = /* @__PURE__ */ de({
  __name: "ScrollRect",
  props: {
    /**
     * Scroll direction
     * 
     * * both : Scroll in both directions
     * * vertical : Scroll only in vertical direction
     * * horizontal : Scroll only in horizontal direction
     * * none : Disable scroll
     * 
     * @default both
     */
    scroll: {
      type: String,
      default: "both"
    },
    /**
     * Show scroll bar always, otherwise show scroll bar when mouse over
     * @default false
     */
    scrollBarAlwaysShow: {
      type: Boolean,
      default: !1
    },
    /**
     * Is able to click scroll bar background to set scroll position? (When `scrollBarAlwaysShow` is true)
     * @default true
     */
    scrollBarBackgroundClickable: {
      type: Boolean,
      default: !1
    },
    /**
     * Height of scroll rect
     */
    height: {
      type: Number,
      default: void 0
    },
    /**
     * Width of scroll rect
     */
    width: {
      type: Number,
      default: void 0
    },
    /**
     * Max height of inner container
     */
    maxHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Max width of inner container
     */
    maxWidth: {
      type: Number,
      default: void 0
    },
    /**
     * CSS class of inner container
     */
    containerClass: {
      type: String,
      default: ""
    },
    /**
     * Container style
     */
    containerStyle: {
      type: null
    },
    /**
     * Specify how many pixels of scroll distance trigger `scrollToStart` event.
     * @default 50
     */
    scrollToStartThreshold: {
      type: Number,
      default: 50
    },
    /**
     * Specify how many pixels of scroll distance trigger `scrollToEnd` event.
     * @default 50
     */
    scrollToEndThreshold: {
      type: Number,
      default: 50
    }
  },
  emits: ["scroll", "resized", "scrollToStart", "scrollToEnd"],
  setup(o, { expose: s, emit: t }) {
    const r = o, a = t, e = d(), v = d(), h = d(), m = d(), c = d(), g = d(), w = d(!1), ee = j(() => r.scroll === "horizontal" || r.scroll === "both"), C = j(() => r.scroll === "vertical" || r.scroll === "both"), f = q({
      show: !1,
      size: 0,
      sizeRaw: 0,
      pos: 0
    }), u = q({
      show: !1,
      size: 0,
      sizeRaw: 0,
      pos: 0
    });
    let z = 0, k = 0, R = 0, Y = 0, T = null;
    const le = { attributes: !0, childList: !0 };
    function L() {
      if (e.value) {
        if (f.show) {
          const l = e.value.offsetWidth / e.value.scrollWidth;
          f.sizeRaw = l * e.value.offsetWidth, f.size = l * 100, f.pos = e.value.scrollLeft / (e.value.scrollWidth - e.value.offsetWidth) * (100 - f.size), l >= 1 && (f.show = !1);
        }
        if (u.show) {
          const l = e.value.offsetHeight / e.value.scrollHeight;
          u.sizeRaw = l * e.value.offsetHeight, u.size = l * 100, u.pos = e.value.scrollTop / (e.value.scrollHeight - e.value.offsetHeight) * (100 - u.size), l >= 1 && (u.show = !1);
        }
        r.scroll === "vertical" ? (r.scrollToStartThreshold && e.value.scrollTop <= r.scrollToStartThreshold && a("scrollToStart"), r.scrollToEndThreshold && e.value.scrollTop >= e.value.scrollHeight - r.scrollToEndThreshold - e.value.offsetHeight && a("scrollToEnd")) : r.scroll === "horizontal" && (r.scrollToStartThreshold && e.value.scrollLeft <= r.scrollToStartThreshold && a("scrollToStart"), r.scrollToEndThreshold && e.value.scrollLeft >= e.value.scrollWidth - r.scrollToEndThreshold - e.value.offsetWidth && a("scrollToEnd")), a("scroll", e.value.scrollLeft, e.value.scrollTop);
      }
    }
    function p(l = !1) {
      if (!e.value)
        return;
      let n = ee.value, i = C.value;
      const ue = n && (z !== e.value.scrollWidth || R !== e.value.offsetWidth), fe = C && (k !== e.value.scrollHeight || Y !== e.value.offsetHeight);
      if (!l && !ue && !fe)
        return;
      const y = window.getComputedStyle(e.value);
      (y.overflow === "hidden" || y.overflowX === "hidden") && (n = !1), (y.overflow === "hidden" || y.overflowY === "hidden") && (i = !1), f.show = n, u.show = i, L(), R = e.value.offsetWidth, Y = e.value.offsetHeight, z = e.value.scrollWidth, k = e.value.scrollHeight, a("resized", z, k);
    }
    const X = Z((l) => {
      var n;
      (n = e.value) == null || n.scrollTo({
        left: e.value.scrollLeft + (l ? Se : -140),
        behavior: "smooth"
      });
    }, 120), oe = Z((l) => {
      var n;
      (n = e.value) == null || n.scrollTo({
        top: e.value.scrollTop + (l ? ye : -120),
        behavior: "smooth"
      });
    }, 20);
    function te(l) {
      r.scroll == "horizontal" && (l.deltaMode == 0 && X(l.deltaY > 0), l.preventDefault(), l.stopPropagation());
    }
    function E(l) {
      l.deltaMode == 0 && (X(l.deltaY > 0), l.preventDefault(), l.stopPropagation());
    }
    function P(l) {
      l.deltaMode == 0 && (oe(l.deltaY > 0), l.preventDefault(), l.stopPropagation());
    }
    let M = 0, $ = 0, N = 0, I = 0;
    const V = Q({
      onDown(l) {
        return !h.value || !c.value ? !1 : (M = l.offsetX, $ = l.x - l.offsetX - c.value.offsetLeft, l.preventDefault(), w.value = !0, !0);
      },
      onMove(l, n, i) {
        e.value && h.value && (U(i.x - M - $), i.preventDefault(), i.stopPropagation());
      },
      onUp() {
        w.value = !1;
      }
    }), O = Q({
      onDown(l) {
        return !m.value || !g.value ? !1 : (N = l.offsetY, I = l.y - l.offsetY - g.value.offsetTop, l.preventDefault(), w.value = !0, !0);
      },
      onMove(l, n, i) {
        e.value && m.value && (A(i.y - N - I), i.preventDefault(), i.stopPropagation());
      },
      onUp() {
        w.value = !1;
      }
    });
    function se(l) {
      e.value && (e.value.scrollLeft = l / 100 * (e.value.scrollWidth - e.value.offsetWidth));
    }
    function re(l) {
      e.value && (e.value.scrollLeft = l / 100 * (e.value.scrollHeight - e.value.offsetHeight));
    }
    function U(l) {
      e.value && (e.value.scrollLeft = l / (e.value.offsetWidth - f.sizeRaw) * (e.value.scrollWidth - e.value.offsetWidth));
    }
    function A(l) {
      e.value && (e.value.scrollTop = l / (e.value.offsetHeight - u.sizeRaw) * (e.value.scrollHeight - e.value.offsetHeight));
    }
    function ae(l) {
      r.scrollBarBackgroundClickable && U(l.offsetX - f.sizeRaw / 2);
    }
    function ne(l) {
      r.scrollBarBackgroundClickable && A(l.offsetY - u.sizeRaw / 2);
    }
    const {
      startResizeChecker: ie,
      stopResizeChecker: ce
    } = Te(
      e,
      () => p(),
      () => p()
    );
    return me(() => {
      ge(() => {
        setTimeout(() => p(!0), 200), p(!0), ie(), T = new MutationObserver(() => p()), T.observe(e.value, le);
      });
    }), pe(() => {
      ce(), T && (T.disconnect(), T = null);
    }), s({
      refreshScrollState() {
        p(!0);
      },
      getScrollContainer() {
        return e.value;
      },
      scrollTo(l, n) {
        var i;
        (i = e.value) == null || i.scrollTo(l, n);
      },
      scrollToTop() {
        var l;
        (l = e.value) == null || l.scrollTo(0, 0);
      },
      scrollToBottom() {
        var l;
        (l = e.value) == null || l.scrollTo(e.value.scrollWidth, e.value.scrollHeight);
      }
    }), (l, n) => (G(), F("div", {
      ref_key: "scrollrect",
      ref: v,
      class: J([
        "vue-scroll-rect",
        o.scrollBarAlwaysShow ? "always-show-scrollbar" : "",
        o.scrollBarBackgroundClickable ? "background-clickable" : "",
        w.value ? "dragging" : ""
      ]),
      style: b({
        width: o.width ? `${o.width}px` : void 0,
        height: o.height ? `${o.height}px` : void 0
      }),
      onWheel: te
    }, [
      W("div", {
        ref_key: "container",
        ref: e,
        class: J(["scroll-content", o.scroll, o.containerClass]),
        style: b({
          maxWidth: o.maxWidth ? `${o.maxWidth}px` : void 0,
          maxHeight: o.maxHeight ? `${o.maxHeight}px` : void 0,
          ...o.containerStyle
        }),
        onScroll: L
      }, [
        D(l.$slots, "default")
      ], 38),
      f.show ? D(l.$slots, "scrollBarX", {
        key: 0,
        scrollBarValue: f,
        onScroll: se
      }, () => [
        W("div", {
          ref_key: "scrollBarRefX",
          ref: h,
          class: "scrollbar horizontal",
          onClick: ae,
          onWheel: E
        }, [
          W("div", {
            class: "thumb",
            ref_key: "scrollBarThumbRefX",
            ref: c,
            style: b({ left: `${f.pos}%`, width: `${f.size}%` }),
            onMousedown: n[0] || (n[0] = //@ts-ignore
            (...i) => B(V) && B(V)(...i)),
            onWheel: E
          }, null, 36)
        ], 544)
      ]) : x("", !0),
      u.show ? D(l.$slots, "scrollBarY", {
        key: 1,
        scrollBarValue: u,
        onScroll: re
      }, () => [
        u.show ? (G(), F("div", {
          key: 0,
          ref_key: "scrollBarRefY",
          ref: m,
          class: "scrollbar vertical",
          onClick: ne,
          onWheel: P
        }, [
          W("div", {
            class: "thumb",
            ref_key: "scrollBarThumbRefY",
            ref: g,
            style: b({ top: `${u.pos}%`, height: `${u.size}%` }),
            onMousedown: n[1] || (n[1] = //@ts-ignore
            (...i) => B(O) && B(O)(...i)),
            onWheel: P
          }, null, 36)
        ], 544)) : x("", !0)
      ]) : x("", !0)
    ], 38));
  }
}), He = {
  install(o) {
    o.component("scroll-rect", be);
  }
};
export {
  be as ScrollRect,
  ke as createMiniTimeOut,
  we as createMiniTimer,
  ze as createMouseDownAndUpHandler,
  Q as createMouseDragHandler,
  He as default,
  Z as throttle,
  Te as useResizeChecker
};
//# sourceMappingURL=vue-scroll-rect.es.js.map
